import React from 'react'
import ReactDOM from 'react-dom'
import 'babel-polyfill'
import {Router, Route, Switch} from 'react-router-dom'
import {history} from './history'
import {routeConfig} from './route'
import {printRecruitConsoleMessageInPrdEnv, getRunningEnv, deviceType} from '@/sc_utils/env-helper'
import {initBaiduStatistics} from '@/sc_utils/statistics'
import eruda from 'eruda'
import '@/sc_style/rem.js'
import '@/sc_style/reset.scss'

const App = () => (
	<Switch>
		{routeConfig.map((routeProps, index) => <Route {...routeProps} exact key={index}/>)}
	</Switch>
)

ReactDOM.render(
	<Router history={history}>
		<Route component={App}/>
	</Router>,
	document.getElementById('root')
)

initBaiduStatistics()

// 开发调试
if (['STG', 'STG2', 'DEBUG'].indexOf(getRunningEnv()) !== -1) {
	// eruda.init();
	// eruda.show();
}

printRecruitConsoleMessageInPrdEnv()
// HMR热更新，勿删，不影响生产发布
module.hot && module.hot.accept()
